import React from 'react';
interface PageHeaderProps {
  title: string;
  subtitle?: string;
  backgroundImage?: string;
  badge?: string;
  badgeText?: string;
  bgColor?: string;
}
export function PageHeader({
  title,
  subtitle,
  backgroundImage = 'https://cdn.magicpatterns.com/uploads/i1cBu4SCd9zBRRuRA5DHDj/e6d6e1d0-61b9-4bb2-8f61-d60c70afaa57.jpg',
  badge,
  badgeText,
  bgColor = 'bg-charcoal'
}: PageHeaderProps) {
  const displayBadge = badge || badgeText;
  return <div className={`relative py-24 md:py-32 flex items-center justify-center overflow-hidden ${bgColor}`} data-id="element-273">
      {/* Background Image with Overlay */}
      {!bgColor.includes('gradient') && <div className="absolute inset-0 z-0" data-id="element-274">
          <div className="absolute inset-0 bg-charcoal/80 z-10" data-id="element-275"></div>
          <img src={backgroundImage} alt={title} className="w-full h-full object-cover opacity-50" data-id="element-276" />
        </div>}

      <div className="container mx-auto px-4 relative z-20 text-center" data-id="element-277">
        {displayBadge && <span className="inline-block px-4 py-1 rounded-full bg-white/10 border border-white/20 text-white text-sm font-medium mb-6 backdrop-blur-sm animate-fadeIn" data-id="element-278">
            {displayBadge}
          </span>}
        <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6 animate-fadeInUp" data-id="element-279">
          {title}
        </h1>
        {subtitle && <p className="text-lg md:text-xl text-gray-300 max-w-2xl mx-auto leading-relaxed animate-fadeInUp animation-delay-100 font-light" data-id="element-280">
            {subtitle}
          </p>}
      </div>
    </div>;
}